export default "__VITE_ASSET__DFXpib2c__"